export default "__VITE_ASSET__m57XiUm4__"